export default __webpack_public_path__ + "static/media/guard1.050e9985.jpg";